import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowUp } from "react-icons/fa";

const FooterTwo = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when scrolled more than 200px
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    // Scroll smoothly to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <>
            <footer className="footer-area footer-dark">
                <div className="container">
                    <div className="footer-bottom">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="footer-copyright">
                                    <span className="copyright-text">
                                        © {new Date().getFullYear()}. All rights reserved by{" "}
                                        <a href="https://axilthemes.com/">Axilthemes</a>.
                                    </span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="footer-bottom-link">
                                    <ul className="list-unstyled">
                                        <li><Link to={"/privacy-policy"}>Privacy Policy</Link></li>
                                        <li><Link to={"/terms-use"}>Terms of Use</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Fade-up Scroll to Top Button */}
                <button
                    id="back-top"
                    className={`back-to-top ${isVisible ? 'show' : ''}`}
                    onClick={scrollToTop}
                    aria-label="Scroll to top"
                >
                    <FaArrowUp />
                </button>
            </footer>
        </>
    );
};

export default FooterTwo;
